import { jsx as N } from "react/jsx-runtime";
import * as j from "react";
import i, { createContext as F, useMemo as M, createElement as I, useContext as oe, useRef as h, useEffect as O, useCallback as q, useState as z, useLayoutEffect as ve, Children as Ce, cloneElement as Ae, useReducer as xe, forwardRef as T } from "react";
import { c as ee } from "./index-SYE1cn5_.js";
import { a as P, $ as G, _ as g } from "./index-D_37ItTm.js";
import { $ as R } from "./index-C6eS9p6d.js";
import { r as ge } from "./index-2hJuj4UN.js";
function H(e, t = []) {
  let n = [];
  function o(r, s) {
    const l = /* @__PURE__ */ F(s), d = n.length;
    n = [
      ...n,
      s
    ];
    function a(f) {
      const { scope: m, children: b, ...p } = f, x = (m == null ? void 0 : m[e][d]) || l, C = M(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ I(x.Provider, {
        value: C
      }, b);
    }
    function u(f, m) {
      const b = (m == null ? void 0 : m[e][d]) || l, p = oe(b);
      if (p) return p;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${r}\``);
    }
    return a.displayName = r + "Provider", [
      a,
      u
    ];
  }
  const c = () => {
    const r = n.map((s) => /* @__PURE__ */ F(s));
    return function(l) {
      const d = (l == null ? void 0 : l[e]) || r;
      return M(
        () => ({
          [`__scope${e}`]: {
            ...l,
            [e]: d
          }
        }),
        [
          l,
          d
        ]
      );
    };
  };
  return c.scopeName = e, [
    o,
    he(c, ...t)
  ];
}
function he(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map(
      (c) => ({
        useScope: c(),
        scopeName: c.scopeName
      })
    );
    return function(r) {
      const s = o.reduce((l, { useScope: d, scopeName: a }) => {
        const f = d(r)[`__scope${a}`];
        return {
          ...l,
          ...f
        };
      }, {});
      return M(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function _e(e) {
  const t = e + "CollectionProvider", [n, o] = H(t), [c, r] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (b) => {
    const { scope: p, children: x } = b, C = i.useRef(null), v = i.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ i.createElement(c, {
      scope: p,
      itemMap: v,
      collectionRef: C
    }, x);
  }, l = e + "CollectionSlot", d = /* @__PURE__ */ i.forwardRef((b, p) => {
    const { scope: x, children: C } = b, v = r(l, x), $ = P(p, v.collectionRef);
    return /* @__PURE__ */ i.createElement(G, {
      ref: $
    }, C);
  }), a = e + "CollectionItemSlot", u = "data-radix-collection-item", f = /* @__PURE__ */ i.forwardRef((b, p) => {
    const { scope: x, children: C, ...v } = b, $ = i.useRef(null), A = P(p, $), _ = r(a, x);
    return i.useEffect(() => (_.itemMap.set($, {
      ref: $,
      ...v
    }), () => void _.itemMap.delete($))), /* @__PURE__ */ i.createElement(G, {
      [u]: "",
      ref: A
    }, C);
  });
  function m(b) {
    const p = r(e + "CollectionConsumer", b);
    return i.useCallback(() => {
      const C = p.collectionRef.current;
      if (!C) return [];
      const v = Array.from(C.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (_, y) => v.indexOf(_.ref.current) - v.indexOf(y.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: d,
      ItemSlot: f
    },
    m,
    o
  ];
}
function ce(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(c) {
    if (e == null || e(c), n === !1 || !c.defaultPrevented) return t == null ? void 0 : t(c);
  };
}
function re(e) {
  const t = h(e);
  return O(() => {
    t.current = e;
  }), M(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function Y({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, c] = Ne({
    defaultProp: t,
    onChange: n
  }), r = e !== void 0, s = r ? e : o, l = re(n), d = q((a) => {
    if (r) {
      const f = typeof a == "function" ? a(e) : a;
      f !== e && l(f);
    } else c(a);
  }, [
    r,
    e,
    c,
    l
  ]);
  return [
    s,
    d
  ];
}
function Ne({ defaultProp: e, onChange: t }) {
  const n = z(e), [o] = n, c = h(o), r = re(t);
  return O(() => {
    c.current !== o && (r(o), c.current = o);
  }, [
    o,
    c,
    r
  ]), n;
}
const w = globalThis != null && globalThis.document ? ve : () => {
};
function Ee(e, t) {
  return xe((n, o) => {
    const c = t[n][o];
    return c ?? n;
  }, e);
}
const ae = (e) => {
  const { present: t, children: n } = e, o = Ie(t), c = typeof n == "function" ? n({
    present: o.isPresent
  }) : Ce.only(n), r = P(o.ref, c.ref);
  return typeof n == "function" || o.isPresent ? /* @__PURE__ */ Ae(c, {
    ref: r
  }) : null;
};
ae.displayName = "Presence";
function Ie(e) {
  const [t, n] = z(), o = h({}), c = h(e), r = h("none"), s = e ? "mounted" : "unmounted", [l, d] = Ee(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return O(() => {
    const a = S(o.current);
    r.current = l === "mounted" ? a : "none";
  }, [
    l
  ]), w(() => {
    const a = o.current, u = c.current;
    if (u !== e) {
      const m = r.current, b = S(a);
      e ? d("MOUNT") : b === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(u && m !== b ? "ANIMATION_OUT" : "UNMOUNT"), c.current = e;
    }
  }, [
    e,
    d
  ]), w(() => {
    if (t) {
      const a = (f) => {
        const b = S(o.current).includes(f.animationName);
        f.target === t && b && ge.flushSync(
          () => d("ANIMATION_END")
        );
      }, u = (f) => {
        f.target === t && (r.current = S(o.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", a), t.addEventListener("animationend", a), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", a), t.removeEventListener("animationend", a);
      };
    } else
      d("ANIMATION_END");
  }, [
    t,
    d
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(l),
    ref: q((a) => {
      a && (o.current = getComputedStyle(a)), n(a);
    }, [])
  };
}
function S(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const ye = j.useId || (() => {
});
let Pe = 0;
function ie(e) {
  const [t, n] = j.useState(ye());
  return w(() => {
    n(
      (o) => o ?? String(Pe++)
    );
  }, [
    e
  ]), t ? `radix-${t}` : "";
}
const se = "Collapsible", [Re, le] = H(se), [Se, J] = Re(se), Me = /* @__PURE__ */ T((e, t) => {
  const { __scopeCollapsible: n, open: o, defaultOpen: c, disabled: r, onOpenChange: s, ...l } = e, [d = !1, a] = Y({
    prop: o,
    defaultProp: c,
    onChange: s
  });
  return /* @__PURE__ */ I(Se, {
    scope: n,
    disabled: r,
    contentId: ie(),
    open: d,
    onOpenToggle: q(
      () => a(
        (u) => !u
      ),
      [
        a
      ]
    )
  }, /* @__PURE__ */ I(R.div, g({
    "data-state": Q(d),
    "data-disabled": r ? "" : void 0
  }, l, {
    ref: t
  })));
}), we = "CollapsibleTrigger", Oe = /* @__PURE__ */ T((e, t) => {
  const { __scopeCollapsible: n, ...o } = e, c = J(we, n);
  return /* @__PURE__ */ I(R.button, g({
    type: "button",
    "aria-controls": c.contentId,
    "aria-expanded": c.open || !1,
    "data-state": Q(c.open),
    "data-disabled": c.disabled ? "" : void 0,
    disabled: c.disabled
  }, o, {
    ref: t,
    onClick: ce(e.onClick, c.onOpenToggle)
  }));
}), de = "CollapsibleContent", Te = /* @__PURE__ */ T((e, t) => {
  const { forceMount: n, ...o } = e, c = J(de, e.__scopeCollapsible);
  return /* @__PURE__ */ I(
    ae,
    {
      present: n || c.open
    },
    ({ present: r }) => /* @__PURE__ */ I(De, g({}, o, {
      ref: t,
      present: r
    }))
  );
}), De = /* @__PURE__ */ T((e, t) => {
  const { __scopeCollapsible: n, present: o, children: c, ...r } = e, s = J(de, n), [l, d] = z(o), a = h(null), u = P(t, a), f = h(0), m = f.current, b = h(0), p = b.current, x = s.open || l, C = h(x), v = h();
  return O(() => {
    const $ = requestAnimationFrame(
      () => C.current = !1
    );
    return () => cancelAnimationFrame($);
  }, []), w(() => {
    const $ = a.current;
    if ($) {
      v.current = v.current || {
        transitionDuration: $.style.transitionDuration,
        animationName: $.style.animationName
      }, $.style.transitionDuration = "0s", $.style.animationName = "none";
      const A = $.getBoundingClientRect();
      f.current = A.height, b.current = A.width, C.current || ($.style.transitionDuration = v.current.transitionDuration, $.style.animationName = v.current.animationName), d(o);
    }
  }, [
    s.open,
    o
  ]), /* @__PURE__ */ I(R.div, g({
    "data-state": Q(s.open),
    "data-disabled": s.disabled ? "" : void 0,
    id: s.contentId,
    hidden: !x
  }, r, {
    ref: u,
    style: {
      "--radix-collapsible-content-height": m ? `${m}px` : void 0,
      "--radix-collapsible-content-width": p ? `${p}px` : void 0,
      ...e.style
    }
  }), x && c);
});
function Q(e) {
  return e ? "open" : "closed";
}
const ke = Me, Ve = Oe, Le = Te, Ue = /* @__PURE__ */ F(void 0);
function Be(e) {
  const t = oe(Ue);
  return e || t || "ltr";
}
const E = "Accordion", Fe = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [W, Ge, Ke] = _e(E), [D, ut] = H(E, [
  Ke,
  le
]), X = le(), fe = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { type: n, ...o } = e, c = o, r = o;
  return /* @__PURE__ */ i.createElement(W.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ i.createElement(He, g({}, r, {
    ref: t
  })) : /* @__PURE__ */ i.createElement(ze, g({}, c, {
    ref: t
  })));
});
fe.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [ue, je] = D(E), [be, qe] = D(E, {
  collapsible: !1
}), ze = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: c = () => {
  }, collapsible: r = !1, ...s } = e, [l, d] = Y({
    prop: n,
    defaultProp: o,
    onChange: c
  });
  return /* @__PURE__ */ i.createElement(ue, {
    scope: e.__scopeAccordion,
    value: l ? [
      l
    ] : [],
    onItemOpen: d,
    onItemClose: i.useCallback(
      () => r && d(""),
      [
        r,
        d
      ]
    )
  }, /* @__PURE__ */ i.createElement(be, {
    scope: e.__scopeAccordion,
    collapsible: r
  }, /* @__PURE__ */ i.createElement(pe, g({}, s, {
    ref: t
  }))));
}), He = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: c = () => {
  }, ...r } = e, [s = [], l] = Y({
    prop: n,
    defaultProp: o,
    onChange: c
  }), d = i.useCallback(
    (u) => l(
      (f = []) => [
        ...f,
        u
      ]
    ),
    [
      l
    ]
  ), a = i.useCallback(
    (u) => l(
      (f = []) => f.filter(
        (m) => m !== u
      )
    ),
    [
      l
    ]
  );
  return /* @__PURE__ */ i.createElement(ue, {
    scope: e.__scopeAccordion,
    value: s,
    onItemOpen: d,
    onItemClose: a
  }, /* @__PURE__ */ i.createElement(be, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ i.createElement(pe, g({}, r, {
    ref: t
  }))));
}), [Ye, k] = D(E), pe = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: o, dir: c, orientation: r = "vertical", ...s } = e, l = i.useRef(null), d = P(l, t), a = Ge(n), f = Be(c) === "ltr", m = ce(e.onKeyDown, (b) => {
    var p;
    if (!Fe.includes(b.key)) return;
    const x = b.target, C = a().filter((U) => {
      var B;
      return !((B = U.ref.current) !== null && B !== void 0 && B.disabled);
    }), v = C.findIndex(
      (U) => U.ref.current === x
    ), $ = C.length;
    if (v === -1) return;
    b.preventDefault();
    let A = v;
    const _ = 0, y = $ - 1, V = () => {
      A = v + 1, A > y && (A = _);
    }, L = () => {
      A = v - 1, A < _ && (A = y);
    };
    switch (b.key) {
      case "Home":
        A = _;
        break;
      case "End":
        A = y;
        break;
      case "ArrowRight":
        r === "horizontal" && (f ? V() : L());
        break;
      case "ArrowDown":
        r === "vertical" && V();
        break;
      case "ArrowLeft":
        r === "horizontal" && (f ? L() : V());
        break;
      case "ArrowUp":
        r === "vertical" && L();
        break;
    }
    const me = A % $;
    (p = C[me].ref.current) === null || p === void 0 || p.focus();
  });
  return /* @__PURE__ */ i.createElement(Ye, {
    scope: n,
    disabled: o,
    direction: c,
    orientation: r
  }, /* @__PURE__ */ i.createElement(W.Slot, {
    scope: n
  }, /* @__PURE__ */ i.createElement(R.div, g({}, s, {
    "data-orientation": r,
    ref: d,
    onKeyDown: o ? void 0 : m
  }))));
}), K = "AccordionItem", [Je, Z] = D(K), Qe = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: o, ...c } = e, r = k(K, n), s = je(K, n), l = X(n), d = ie(), a = o && s.value.includes(o) || !1, u = r.disabled || e.disabled;
  return /* @__PURE__ */ i.createElement(Je, {
    scope: n,
    open: a,
    disabled: u,
    triggerId: d
  }, /* @__PURE__ */ i.createElement(ke, g({
    "data-orientation": r.orientation,
    "data-state": $e(a)
  }, l, c, {
    ref: t,
    disabled: u,
    open: a,
    onOpenChange: (f) => {
      f ? s.onItemOpen(o) : s.onItemClose(o);
    }
  })));
}), We = "AccordionHeader", Xe = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, c = k(E, n), r = Z(We, n);
  return /* @__PURE__ */ i.createElement(R.h3, g({
    "data-orientation": c.orientation,
    "data-state": $e(r.open),
    "data-disabled": r.disabled ? "" : void 0
  }, o, {
    ref: t
  }));
}), te = "AccordionTrigger", Ze = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, c = k(E, n), r = Z(te, n), s = qe(te, n), l = X(n);
  return /* @__PURE__ */ i.createElement(W.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ i.createElement(Ve, g({
    "aria-disabled": r.open && !s.collapsible || void 0,
    "data-orientation": c.orientation,
    id: r.triggerId
  }, l, o, {
    ref: t
  })));
}), et = "AccordionContent", tt = /* @__PURE__ */ i.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, c = k(E, n), r = Z(et, n), s = X(n);
  return /* @__PURE__ */ i.createElement(Le, g({
    role: "region",
    "aria-labelledby": r.triggerId,
    "data-orientation": c.orientation
  }, s, o, {
    ref: t,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function $e(e) {
  return e ? "open" : "closed";
}
const ne = fe, nt = Qe, ot = Xe, ct = Ze, rt = tt, bt = (e) => {
  const [t, n] = j.useState(e.id);
  if (e.type === "single" && !Array.isArray(t))
    return /* @__PURE__ */ N(
      ne,
      {
        type: e.type,
        value: t,
        className: ee("accordion", e.className),
        collapsible: !0,
        onValueChange: n,
        children: e.children
      }
    );
  if (e.type === "multiple" && Array.isArray(t))
    return /* @__PURE__ */ N(
      ne,
      {
        type: e.type,
        value: t,
        className: ee("accordion", e.className),
        onValueChange: n,
        children: e.children
      }
    );
}, pt = ({ children: e, id: t }) => /* @__PURE__ */ N(nt, { value: t, className: "accordion__item", children: e }), $t = ({ children: e }) => /* @__PURE__ */ N(ot, { asChild: !0, children: /* @__PURE__ */ N(ct, { className: "accordion__trigger", asChild: !0, children: /* @__PURE__ */ N("div", { children: e }) }) }), mt = ({ children: e }) => /* @__PURE__ */ N(G, { className: "accordion__button", children: e }), vt = ({ children: e }) => /* @__PURE__ */ N(rt, { className: "accordion__content", children: e });
export {
  bt as A,
  pt as a,
  $t as b,
  mt as c,
  vt as d
};
